// Copyright (c) 2016 Deere & Company

import Pip from '@deere/cps-it.warranty-model-factory/lib/pip-history';
import t from 'tcomb';

const Pips = t.list(Pip, 'Pips');

export const getDefaultState = () => new Pips([]);

export default Pips;



// WEBPACK FOOTER //
// ./src/product/details/state/pips.js